var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isError)?_c('div',{staticClass:"s-captcha"},[_c('div',{attrs:{"id":"captcha-container"}}),_vm._t("errors")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }